import React, { useEffect, useState } from 'react';
import { Box, Button, makeStyles, MobileStepper, useTheme } from '@material-ui/core';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

import { MobileRegularPage } from '../../../components';
import CurrentChildrenQty from './CurrentChildrenQty';
import DesiredChildrenQty from "./DesiredChildrenQty";
import { Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const styles = makeStyles((theme) => ({
    footer: {
        width: '100%',
        marginTop: 'auto'
    }
}));

const StepperButton = (props) => {
    return (
        <Button color="secondary" size="large" {...props}>
            {props.children}
        </Button>
    )
}

const Questionary = () => {
    const classes = styles();
    const theme = useTheme();
    const { t } = useTranslation();

    const [activeStep, setActiveStep] = useState(0);

    const [currentChildrenQty, setCurrentChildrenQty] = useState(0);
    const [biologicalChildrenQty, setBiologicalChildrenQty] = useState(0);
    useEffect(() => {
        if (biologicalChildrenQty > currentChildrenQty) setBiologicalChildrenQty(currentChildrenQty);
    }, [currentChildrenQty, biologicalChildrenQty])

    const [desiredChildrenQty, setDesiredChildrenQty] = useState(0);

    const handleCurrentChildrenChange = e => {
        setCurrentChildrenQty(e.target.value);
    };
    const handleBiologicalChildrenChange = (e, value) => {
        setBiologicalChildrenQty(value);
    };
    const handleDesiredChildrenChange = e => {
        setDesiredChildrenQty(e.target.value);
    };

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const [isQuestionaryFinished, setIsQuestionaryFinished] = useState(false);
    const handleFinish = () => {
        setIsQuestionaryFinished(true);
    }

    const NextButton = () => {
        if (activeStep < 1) {
            return (
                <StepperButton onClick={handleNext} disabled={activeStep === 1}>
                    {t('common.form.stepper.button.next')}
                    {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                </StepperButton>
            )
        } else {
            return <StepperButton onClick={handleFinish}>{t('common.form.stepper.button.finish')}</StepperButton>
        }
    }

    return (
        <>
            {
                isQuestionaryFinished &&
                <Redirect to={`/app/fpqquotient/${currentChildrenQty}/${desiredChildrenQty}/${biologicalChildrenQty}`} />
            }
            <MobileRegularPage>
                {activeStep === 0 &&
                    <CurrentChildrenQty
                        onCurrentChildrenQtyChange={handleCurrentChildrenChange}
                        currentChildrenQty={currentChildrenQty}
                        onBiologicalChildrenQtyChange={handleBiologicalChildrenChange}
                        biologicalChildrenQty={biologicalChildrenQty}
                    />}
                {activeStep === 1 &&
                    <DesiredChildrenQty
                        onChildrenQtyChange={handleDesiredChildrenChange}
                        value={desiredChildrenQty} />}
                <Box className={classes.footer}>
                    <MobileStepper
                        variant="dots"
                        steps={2}
                        position="static"
                        activeStep={activeStep}
                        nextButton={<NextButton />}
                        backButton={
                            <StepperButton onClick={handleBack} disabled={activeStep === 0}>
                                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                                {t('common.form.stepper.button.back')}
                        </StepperButton>
                        }
                    />
                </Box>
            </MobileRegularPage>
        </>
    );
};

export default Questionary;